export default "__VITE_ASSET__DBlefXRx__"